import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	gap: 1.5rem;
	align-items: flex-start;
	justify-content: flex-start;
`;

export const saveOrder = styled.div<{ $canSave: boolean }>`
	width: 100%;
	display: flex;
	gap: 1.5rem;
	align-items: center;
	justify-content: flex-end;

	> button {
		all: unset;
		padding: 1rem 2rem;
		text-align: center;
		border-radius: 5px;
		background-color: ${(props) =>
			props.$canSave ? color.system.success : color.interface.lightGray2};
		color: ${color.interface.white};
		font-size: 1.5rem;
		cursor: ${(props) => (props.$canSave ? 'pointer' : 'not-allowed')};
		transition: all ease 0.5s;

		&:hover {
			opacity: 0.5;
		}
	}
`;
